import { Button, Group, Text } from "@mantine/core";
import { useState } from "react";
import { checkoutAddon } from "../api";
import { useStore } from "../store";

export default function ClusterQuota() {
  const packaging = useStore((s) => s.tenantProfile?.packaging);
  const [buying, setBuying] = useState(false);

  if (!packaging) return null;

  const left = packaging.clustersRemaining ?? 0;
  const total =
    (packaging.clustersIncluded ?? 0) + (packaging.clustersExtra ?? 0);

  const buy = async () => {
    setBuying(true);
    try {
      const data = await checkoutAddon("extra-cluster");
      if (data?.redirectUrl) window.location = data.redirectUrl;
    } finally {
      setBuying(false);
    }
  };

  return (
    <Group gap="sm" wrap="wrap">
      <Text size="sm" c={left === 0 ? "orange" : "dimmed"}>
        {left} of {total} researched cluster{total === 1 ? "" : "s"} left this
        month
      </Text>
      {left === 0 && (
        <Button size="xs" variant="light" loading={buying} onClick={buy}>
          Extra cluster $19
        </Button>
      )}
    </Group>
  );
}
